<template>
  <!--  <div>-->

  <b-form-group >
<!--    {{fieldsData}}-->
    <b-form-checkbox
        @input="UpdateValue($event)"
        :checked="ischecked(fieldsData.id)"
        :required="isRequired(fieldsData.required)">
      <span v-html="fieldsData.label[selectlang]"></span>

    </b-form-checkbox>
<!--    <small class="text-danger" v-if="fieldsData.id==''">{{ fieldsData.error[selectlang] }}</small>-->

    <!--      <label v-if="fieldsData.fieldType=='CheckBox'&&fieldsData.visible==1" v-html="fieldsData.label[0]"></label>-->
    <!--        <small class="text-danger">{{ errors[0] }}</small>-->
    <!--      </validation-provider>-->
  </b-form-group>
  <!--  </div>-->
</template>

<script>

import {BFormCheckbox,} from "bootstrap-vue";
export default {

  props: ['fieldsData','selectlang',],
  components: {
    BFormCheckbox,
  },
  data() {
    return {

    };
  },


  created() {
    // Convert fieldsData.id to an array of integers
    // this.fieldsData.id = this.fieldsData.id.split(',').map(item => parseInt(item.trim()));
    // // Set isChecked based on the presence of fieldsData.id in the selected values
    // this.isChecked = this.fieldsData.id.some(id => id === parseInt(this.fieldsData.id));
  },

  methods: {
    isRequired(requiredValue) {

      // Check if fieldsData.required is equal to 1
      return requiredValue == 1;
    },
    ischecked(checkedValue) {
      // Check if fieldsData.required is equal to 1
      return checkedValue == 1;
    },
    UpdateValue(value) {
      let valuechecked=value;
      let value1 = valuechecked ==true? '1':'0';
      let targetField=this.fieldsData.targetField;
      let targetValue=this.fieldsData.targetValue;
      this.$emit('input', value1)
      // alert(value1);
      this.$emit('wtsappupdate', value,targetValue,targetField)
    },
  },
}
</script>

<style>
/* Add your styles here */
</style>
